module.exports = __webpack_public_path__ + "static/media/ic_ascensor.a15dbd98.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_ascensor.webp
// module id = 174
// module chunks = 1